import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const EvBatterySizingGuidePage = () => <DataDrivenGuidePage slug="guide-ev-battery-sizing" />;

export default EvBatterySizingGuidePage;
